/** Canonical periods may be opaque IDs. Only display labels whose meaning is readable without guessing. */
export function readableOkrPeriod(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const label = value.trim();
  if (!label || label.length > 80) return null;
  return /\p{Script=Han}/u.test(label) ||
      /^(?:(?:FY\s?)?\d{4}[- /]?(?:Q[1-4]|H[12])|(?:Q[1-4]|H[12])\s+\d{4})$/i
        .test(label)
    ? label
    : null;
}
